import trimEnd from 'lodash/trimEnd';
import trimStart from 'lodash/trimStart';

export default class BaseRepository {
  protected static setBaseUrl = (baseUrl: string, route: string) => {
    const apiUrl = trimEnd(baseUrl, '/');
    const apiRoute = trimStart(route, '/');

    return `${apiUrl}/${apiRoute}`;
  };
}
